<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Cyber Security &
                        AI</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Diploma in Artifical Intelligence and Machine Learning</td>
                        </tr>
                        <tr>
                            <td class="time">Diploma in Forensic Science & Cyber Security</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Cyber Security and AI</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Artificial Intelligence and Machine
                    Learning </b>
                    – The Diploma in Artificial Intelligence and Machine Learning at ARNI School of Technology is
                    designed to give subject-specific skills including programming languages, AI and ML fundamentals and
                    principals, and database management. This one-year diploma is divided into 2 semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Foundation</p>
                <ul>
                    <li> Relational Database Management System (RDBMS)</li>
                    <li> Fundamentals of Artificial Intelligence</li>
                    <li> R Programming</li>
                    <li> Basic Mathematics</li>
                    <li> Communications Skills</li>
                    <li> R Programming Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Core Concept</p>
                <ul>
                    <li> Principles of Soft Computing</li>
                    <li> Fundamentals of Machine Learning</li>
                    <li> Communication Skill</li>
                    <li> Python Programming</li>
                    <li> Machine Learning using Python Lab</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Forensic Science & Cyber Security </b> –
                    The techniques needed to stop computer systems and networks from leaking information or damaging
                    hardware, software, or electronic data are the main focus of the ARNI School of Technology's Diploma
                    in Forensic Science & Cyber Security program. Additionally, it provides in-depth instruction on
                    crime scene investigation, physical evidence processing, and other crucial forensic science facts.
                    There are two semesters in this one-year diploma program.
                </p>
            </div>


            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I
                </b>: Foundation</p>
                <ul>
                    <li> Principles of Soft Computing</li>
                    <li> Introduction to Cyber Laws and Cyber Space</li>
                    <li> Basics of Computer & Cyber Forensics</li>
                    <li> Basics of Cyber Security</li>
                    <li> Ethics, Policies and the IT Act</li>
                    <li> Practical</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II

                </b>: Core Concepts</p>
                <ul>
                    <li> Advanced Tools of Cyber Security</li>
                    <li> Advanced Investigation in Digital Forensics</li>
                    <li> Trademark, Copyrights and Patent Laws</li>
                    <li> Implementation Practical on MATLAB</li>
                    <li> Practical</li>
                </ul>
            </div>

        </div>
    </div>
</section>
